import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.25 7a.75.75 0 0 0 1.5 0V5.75h6.5V7a.75.75 0 0 0 1.5 0V5.75H20a.25.25 0 0 1 .25.25v2a.75.75 0 0 0 1.5 0V6A1.75 1.75 0 0 0 20 4.25h-3.25V3a.75.75 0 0 0-1.5 0v1.25h-6.5V3a.75.75 0 0 0-1.5 0v1.25H4A1.75 1.75 0 0 0 2.25 6v13c0 .966.784 1.75 1.75 1.75h4a.75.75 0 0 0 0-1.5H4a.25.25 0 0 1-.25-.25V6A.25.25 0 0 1 4 5.75h3.25zm3.928 9.512a1.75 1.75 0 0 0 0 2.475l.417.418.175.175.428.428.508-.328a.61.61 0 0 1 .753.102c.22.22.239.539.101.753l-.327.508.427.428.184.183.418.418a1.75 1.75 0 0 0 2.474 0l5.336-5.334a1.75 1.75 0 0 0 0-2.475l-.6-.6-.432-.433-.51.337a.61.61 0 0 1-.758-.098.61.61 0 0 1-.098-.758l.337-.51-.433-.433-.59-.59a1.75 1.75 0 0 0-2.475 0zm1.06 1.414a.25.25 0 0 1 0-.353l5.336-5.335a.25.25 0 0 1 .353 0l.23.23a2.12 2.12 0 0 0 .554 2.062c.556.555 1.349.75 2.06.554l.24.24a.25.25 0 0 1 0 .353l-5.335 5.335a.25.25 0 0 1-.354 0l-.244-.245a2.13 2.13 0 0 0-.558-2.046 2.13 2.13 0 0 0-2.046-.558z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }